import React from "react"
//import PropTypes from 'prop-types';
import { DropTarget } from "react-dnd"
import ContainerDimensions from "react-container-dimensions"
import { connect } from "../../utils"
import { CarouselList } from "./carouselAnimation"

const target = {
  drop(props, monitor, component) {
    if (!monitor.didDrop()) {
      props.layoutState.insertOrMoveItem(
        props.id,
        props.children.length,
        monitor.getItem()
      )
    }
  },
}
const EditLayout = ({
  id,
  children,
  isOverCurrent,
  connectDropTarget,
  type,
  layoutState,
  readOnly,
}) => {
  return connectDropTarget(
    <div
      style={{
        boxSizing: "border-box",
        position: "relative",
        height: "auto",
        display: "flex",
        width: "100%",
        justifyContent: "center",
        flex: 1,
      }}
    >
      <ContainerDimensions>
        {({ width, height }) => {
          return (
            <CarouselList
              data={layoutState.getItemJS(id).props.values}
              widthContainer={width}
              heightContainer={height}
            />
          )
        }}
      </ContainerDimensions>
    </div>
  )
}

const LayoutContainer = DropTarget(
  "CarouselAnimationView",
  target,
  (conn, monitor) => ({
    connectDropTarget: conn.dropTarget(),
    isOverCurrent: monitor.isOver({ shallow: true }),
  })
)(EditLayout)

export default connect("layoutState", "readOnly")(LayoutContainer)



// WEBPACK FOOTER //
// ./src/editor/layout/components/Layout/DnDCarouselAnimation.js